/* Dependencies */
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

// Redux
import { store } from "./store/store";

// Core
import reportWebVitals from "./reportWebVitals";

// Components
import App from "./App";

// Styles
import "./index.css";

// Create Root Element & Render component.
const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
